var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-1 top-sticky-brf"},[_c('display-timer-counter',{attrs:{"start":_vm.isStart,"startTime":parseInt(_vm.question.elapsed) ? parseInt(_vm.question.elapsed) : 0},on:{"tick":(_elapsed) => (_vm.question.elapsed = _elapsed)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }